<template>
  <div id="payu-pay-popup-button" ref="payu-pay-popup-button"></div>
</template>

<script>
import Axios from 'axios'

import Cart from '@/cart'
import Utils from '@/utils'
import PaymentService from '@/service/Payment'

export default {
  props: ['paymentOptions'],
  data() {
    return {
      Cart: Cart,
      cartTotalPrice: Cart.innerPrice,
      complete: false,
      keys: {
        sig: null
      },
      stripe: null,
      elements: null,
      card: {
        number: null,
        expiry: null,
        cvc: null
      },
      stripeLoaded: true,
      cardNumberInvalid: false,
      cardExpiryInvalid: false,
      cardCvcInvalid: false,

      paying: false
    }
  },
  watch: {
    cartTotalPrice : {
      deep: true,
      handler() {
        this.getSigAndInsertSctipt()
      }
    }
  },
  components: {},
  async created() {
    console.log('PayUPopup:create')

    this.getSigAndInsertSctipt()

    this.$parent.$parent.$off('submitPayment')
    this.$parent.$parent.$on('submitPayment', () => {
      console.log('Customer clicked to pay the order')
      this.pay();
    });

    // This is here to allow call back after the card form was filled.
    window.successfulPayment = (tokenData) => {
      this.processToken(tokenData)
    }

  },
  methods: {
    dontSubmit(event) {
      event.preventDefault()
    },
    checkForm(event) {
      console.log('Submitting', event)
      event.preventDefault()
      event.stopPropagation()
    },
    async processToken(tokenData) {
      console.log(tokenData)
      Utils.scrollTo({
        targetElementId: 'final-step'
      })
      const chargeData = (await PaymentService.action('PAYU-POPUP', 'charge', tokenData))
      console.log('Token submited and payed', chargeData)
      if (chargeData.result && chargeData.result.status && chargeData.result.status.statusCode == 'SUCCESS') {
        console.log('Yee ... but wait for the webhook')
        if (chargeData.result.redirectUri) {
          window.location = chargeData.result.redirectUri
        } else {
          // console.log('SUCCEEDED', chargeData.result.orderNumber)
          // Cart.closeOrder(chargeData.result.orderNumber)
        }
      } else if (chargeData.result && chargeData.result.status && chargeData.result.status.statusCode == 'WARNING_CONTINUE_3DS') {
        if (chargeData.result.redirectUri) {
          window.location = chargeData.result.redirectUri
        }
      } else {
        console.error('Nope')
      }
    },
    async pay() {
      console.log('PayUPopup.vue:pay() Getting redirect URI')
      this.paying = true

      console.log('Emitting click')
      document.getElementById('payu-pay-popup-button').click()

    },
    async getSigAndInsertSctipt() {
      const gateData = (await PaymentService.action('PAYU-POPUP', 'start', {}))
      console.log('gateData with SIG', gateData)

      this.insertScript(gateData.sig)
    },
    insertScript(sig) {
      if (this.paying == true) {
        console.log('Not going to change the script... the payment already in progress.')
        return
      }
      let paymentConfig = Cart.shopData.payments.methods.filter(m => {
        return m.code == 'CARD_ONLINE';
      })
      console.log('Payment config', paymentConfig)

      if (paymentConfig.length == 1) {
        // Remove possibly previous script
        let elements = document.querySelector(`script[id='payPopupUScript']`)
        while (elements != null) {
          console.log('>> Removing previous script')
          elements.remove()
          elements = document.querySelector(`script[id='payPopupUScript']`)
        }
        elements = document.querySelector(`script[src*='payu.com/front/widget/js/payu-widget.js']`)
        while (elements != null) {
          console.log('>> Removing previous script')
          elements.remove()
          elements = document.querySelector(`script[src*='payu.com/front/widget/js/payu-widget.js']`)
        }

        let domain = process.env.VUE_APP_ENVIRONMENT != 'production' ? 'snd.' : ''
        let payuScript = document.createElement('script')
        payuScript.setAttribute('src', `https://secure.${domain}payu.com/front/widget/js/payu-bootstrap.js`)
        payuScript.setAttribute('id', 'payPopupUScript')
        payuScript.setAttribute('merchant-pos-id', paymentConfig[0].optionProperties.clientId.trim())
        payuScript.setAttribute('shop-name', Cart.shopData.shopName) // 'TESTA'   Cart.shopData.shopName
        payuScript.setAttribute('total-amount', Cart.data.total * 100)
        payuScript.setAttribute('currency-code', Cart.data.currency)
        payuScript.setAttribute('widget-mode', 'pay')
        payuScript.setAttribute('pay-button', '#payu-pay-popup-button') //
        payuScript.setAttribute('customer-language', Cart.shopData.defaultLang)
        payuScript.setAttribute('customer-email', Cart.data.userIdentification)
        payuScript.setAttribute('success-callback', 'successfulPayment')
        payuScript.setAttribute('payu-brand', false)
        payuScript.setAttribute('sig', sig)
        document.head.appendChild(payuScript)
      }

      console.log('Script inserted')
    }

  }
}
</script>

<style lang='less' scoped>
@import '../../../variables.less';

</style>
